import { useSelector } from 'react-redux';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function LoadingIcon() {
  const { theme } = useSelector((state) => state.ui);
  return (
    <div className="flex flex-row justify-center items-center h-full">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{
          margin: 'auto',
          background: 'none',
          display: 'block',
          shapeRendering: 'auto',
          maxWidth: '100px',
        }}
        width="200px"
        height="200px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke={theme.brandColour || DEFAULT_PRIMARY_COLOUR}
          strokeWidth="6"
          r="35"
          strokeDasharray="164.93361431346415 56.97787143782138"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="1s"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
          />
        </circle>
      </svg>
    </div>
  );
}
